<template>
<div :class="['card', {'card-blend': blend, 'card-tab': hasTabs}]">
  <div :class="['card-header']" v-if="flexTitle || hasTabs" v-on:click="emitClickHeader">
    <div class="card-title" v-if="flexTitle">
      <a v-if="btnBack" class="btn-back" v-on:click="emitBack">
        <i class="fa fa-angle-left" aria-hidden="true"></i>
      </a>
      <span v-if="icon" :class="['circle', 'circle-' + iconColor, 'mright-15']">
        <i :class="[iconPrefixClass, 'fa-' + icon]" aria-hidden="true"></i>
      </span>
      <img v-if="imageUrl" :alt="flexTitle" :src="imageUrl" :width="imageWidth" :height="imageHeight" class="mright-10" />
      <span v-html="flexTitle"></span>
    </div>
    <ul v-if="hasTabs && !isPrintView" class="nav nav-tabs">
      <li v-for="(tab, index) in tabs" v-show="!tab.hidden" :role="tabId(tab.id)" :class="{'active': activeTab == tab.id}" :data-badge="tab.badge" :data-badge-color="tab.badgeColor">
        <a :aria-controls="tabId(tab.id)" role="tab" data-toggle="tab" aria-expanded="{'true': activeTab == tab.id, 'false': activeTab != tab.id}" v-on:click="openTab(tab.id)">
          <template v-if="tab.icon">
            <i :class="[tab.iconPrefix, 'fa-' + tab.icon]" aria-hidden="true"></i>
            <span class="hidden-xs mleft-10">{{ tab.title }}</span>
          </template>
          <template v-else>
            {{ tab.title }}
          </template>
        </a>
      </li>
    </ul>
    <ul class="card-action">
      <li v-if="dropdown" class="dropdown">
        <a href="/" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
          <i class="fa fa-cogs" aria-hidden="true"></i>
        </a>
        <ul class="dropdown-menu">
          <li v-for="link in dropdown"><a v-on:click="link.onclick">{{ link.title }} </a></li>
        </ul>
      </li>
      <li v-if="refresh">
        <a v-on:click="refresh">
          <i class="fa fa-refresh"></i>
        </a>
      </li>
      <li v-if="collapsable">
        <i :class="['fas', 'fa-caret-right', 'fa-2x', 'transition-transform', {'fa-rotate-90': show}]"></i>
      </li>
      <li>
        <slot name="buttons"></slot>
      </li>
    </ul>
  </div>

  <transition name="slide-fade">
    <div :class="['card-body', bodyClass, {'__loading': loader, 'tab-content': hasTabs}]" v-show="show">
      <alert
        :title="alert"
        :text="alertText"
        :color="alertStyle"
        :icon="alertIcon"
        :dismissable="alertDismissable"
        v-on:dismiss="dismissAlert"
      ></alert>
      <div v-show="loader" class="loader-container text-center">
        <div class="icon">
          <div class="sk-wave">
            <div class="sk-rect sk-rect1"></div>
            <div class="sk-rect sk-rect2"></div>
            <div class="sk-rect sk-rect3"></div>
            <div class="sk-rect sk-rect4"></div>
            <div class="sk-rect sk-rect5"></div>
          </div>
        </div>
        <div class="title">{{ loader }}</div>
      </div>
      <slot></slot>
    </div>
  </transition>
</div>
</template>
<script>
export default {
  props: {
    activeTab: {
      type: String,
      default: ''
    },
    alert: {
      type: String
    },
    alertText: {
      type: String
    },
    alertStyle:  {
      type: String
    },
    alertIcon:  {
      type: String
    },
    alertDismissable: {
      type: Boolean,
      default: false
    },
    blend: {},
    bodyClass: {},
    btnBack: {},
    // NOT IMPLEMENTED YET
    dropdown: {
      type: Object
    },
    loader: {
      type: String
    },
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    icon: {
      type: String
    },
    iconPrefix: {
      type: String
    },
    iconColor: {
      type: String,
      default: 'grey'
    },
    imageUrl: {
      type: String
    },
    imageHeight: {},
    imageWidth: {},
    title: {
      type: String
    },
    refresh: {
      type: Function
    },
    show: {
      type: Boolean,
      default: true
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    isPrintView: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hasTabs() {
      return this.tabs.length > 1;
    },
    flexTitle() {
      return this.tabs.length == 1 ? this.tabs[0].title : this.title;
    },
    iconPrefixClass() {
      return !this.iconPrefix || this.iconPrefix === '' ? 'fa' : this.iconPrefix;
    }
  },
  methods: {
    dismissAlert() {
      this.$emit('dismissalert');
    },
    emitBack() {
      this.$emit('back');
    },
    registerTab(tab) {
      this.tabs.push(tab);
    },
    setBadge(tabId, content, color) {
      this.tabs.each()
    },
    openTab(id) {
      this.$emit('change', id);
      // Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders.
      // this.activeTab = id;
    },
    tabId(id) {
      return 'tab_' + id;
    },
    emitClickHeader() {
      this.$emit('clickheader');
    }
  }
}
</script>

<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.transition-transform {
  transition: transform .3s ease;
}
</style>
